/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theme_Cycle_To_DarkInputs */

const cs_theme_cycle_to_dark = /** @type {(inputs: Theme_Cycle_To_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Světlý režim — přepnout na tmavý`)
};

const en_theme_cycle_to_dark = /** @type {(inputs: Theme_Cycle_To_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light mode — switch to dark`)
};

/**
* | output |
* | --- |
* | "Light mode — switch to dark" |
*
* @param {Theme_Cycle_To_DarkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const theme_cycle_to_dark = /** @type {((inputs?: Theme_Cycle_To_DarkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theme_Cycle_To_DarkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_theme_cycle_to_dark(inputs)
	return cs_theme_cycle_to_dark(inputs)
});